import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import PlanningServices from '../services/planning.service';
import { setMessage } from './message';


export const fetchPlanningList = createAsyncThunk(
  'planninglist/fetchPlanningList',
  async ({ page, pagesize, search, ordering }, thunkAPI) => {
    try {
      const response = await PlanningServices.getPlanningList(page, pagesize, search, ordering);
      return response.data; // Return the full response
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  },
);

export const fetchPlanningListByField = createAsyncThunk(
  'planninglist/fetchPlanningListByField',
  async ({ pressID, page, pagesize, search, ordering }, thunkAPI) => {
    try {
      const response = await PlanningServices.getPlanningListByField(pressID, page, pagesize, search, ordering);
      return response.data; // Return the full response
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  },
);

export const fetchPriorityList = createAsyncThunk(
  'planninglist/fetchPriorityList',
  async ({ page, pagesize, search, ordering }, thunkAPI) => {
    try {
      const response = await PlanningServices.getPriorityList(page, pagesize, search, ordering);
      return {
        results: {
          success: response.data.results.success,
          data: response.data.results.data,
        },
        count: response.data.count,
        next: response.data.next,
        previous: response.data.previous,
      }; // Restructure the response
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  },
);

export const RemovePriorityItems = createAsyncThunk(
  'planninglist/RemovePriorityItems',
  async ({ id }, thunkAPI) => {
    try {
      const response = await PlanningServices.removePriority(id);
      return response.data; // Return the full response
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  },
);

export const fetchPriorityListByID = createAsyncThunk(
  'planninglist/fetchPriorityListByID',
  async ({ id }, thunkAPI) => {
    try {
      const response = await PlanningServices.getPriorityListById(id);
      return {
        results: {
          success: response.data.results.success,
          data: response.data.results.data,
        },
        count: response.data.count,
        next: response.data.next,
        previous: response.data.previous,
      };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  },
);

export const fetchArchivedPlanningList = createAsyncThunk(
  'Planninglist/fetchArchivePlanningList',
  async ({ page, pagesize, search, ordering }, thunkAPI) => {
    try {
      const response = await PlanningServices.getArchivePlanningList(page, pagesize, search, ordering);
      return response.data; // Return the full response
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  },
);
export const createPlanning = createAsyncThunk(
  'Planninglist/createPlanning',
  async ({ values }, thunkAPI) => {
    try {
      const response = await PlanningServices.addPlanning(values);
      return response.data;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const fetchPlanningById = createAsyncThunk(
  'Planninglist/fetchPlanningById',
  async (PlanningId, { rejectWithValue }) => {
    try {
      const response = await PlanningServices.getPlanningById(PlanningId);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const fetchAgeingOptionsById = createAsyncThunk(
  'Planninglist/fetchAgeingOptionsById',
  async ({ alloyId, temperId, page, pagesize, search, ordering }, thunkAPI) => {
    try {
      const response = await PlanningServices.getAgeingOptions(alloyId, temperId, page, pagesize, search, ordering);
      return Array.isArray(response.data.data) ? response.data.data : [];
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);
export const editPlanning = createAsyncThunk(
  'Planninglist/editPlanning',
  async ({ SizeId, SizeData }, thunkAPI) => {
    try {
      const response = await PlanningServices.updatePlanning(SizeId, SizeData);
      return response.data; // Ensure this returns the updated category data
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const archivePlanning = createAsyncThunk(
  'Planninglist/archiveAlloy',
  async (id, thunkAPI) => {
    try {
      await PlanningServices.archivePlanning(id);
      return id; // Return the ID of the deleted alloy
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  },
);
export const unArchivePlanning = createAsyncThunk(
  'Planninglist/unArchivePlanning',
  async (id, thunkAPI) => {
    try {
      await PlanningServices.unArchivePlanning(id);
      return id; // Return the ID of the unarchived alloy
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  },
);

const initialState = {
  data: [], // Data for current page
  list: [], // All fetched data (combined from multiple pages)
  loading: false,
  totalRecord: 0,
  totalPages: 0,
  currentPage: 1,
  status: 'idle',
  error: null,
  hasMore: true,
};

const PlanningSlice = createSlice({
  name: 'Planning',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    resetPlanningList: state => {
      state.list = []; // Clear the entire list
      state.data = []; // Also clear the current page data
    },
    resetCurrentPlanningListPage: state => {
      state.currentPage = 1;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchPlanningList.pending, state => {
        state.status = 'loading';
        state.loading = false;
      })
      .addCase(fetchPlanningList.fulfilled, (state, action) => {
        state.status = 'succeeded';
        const fetchedPage = action.payload.page || state.currentPage;
        state.data = action.payload.results.data || []; // Correctly access the data array
        state.totalRecord = action.payload.count || 0; // Set total records
        state.totalPages = Math.ceil((action.payload.count || 0) / action.meta.arg.limit); // Calculate total pages
        state.currentPage = action.payload.next ? fetchedPage + 1 : fetchedPage;
        state.list = [...state.list, ...action.payload.results.data];
        state.hasMore = !!action.payload.next;
      })
      .addCase(fetchPlanningList.rejected, (state, action) => {
        state.status = 'failed';
        state.loading = false;
        state.error = action.error.message;
      });
    builder
      .addCase(fetchPlanningListByField.pending, state => {
        state.status = 'loading';
        state.loading = false;
      })
      .addCase(fetchPlanningListByField.fulfilled, (state, action) => {
        state.status = 'succeeded';
        const fetchedPage = action.payload.page || state.currentPage;
        state.data = action.payload.results.data || []; // Correctly access the data array
        state.totalRecord = action.payload.count || 0; // Set total records
        state.totalPages = Math.ceil((action.payload.count || 0) / action.meta.arg.limit); // Calculate total pages
        state.currentPage = action.payload.next ? fetchedPage + 1 : fetchedPage;
        state.list = [...state.list, ...action.payload.results.data];
        state.hasMore = !!action.payload.next;
      })
      .addCase(fetchPlanningListByField.rejected, (state, action) => {
        state.status = 'failed';
        state.loading = false;
        state.error = action.error.message;
      });
    builder
      .addCase(fetchPriorityList.pending, state => {
        state.status = 'loading';
        state.loading = false;
      })
      .addCase(fetchPriorityList.fulfilled, (state, action) => {
        state.status = 'succeeded';
        const fetchedPage = action.meta.arg.page || state.currentPage; // Use page from thunk args
        state.data = action.payload.results.data || []; // Access results.data
        state.totalRecord = action.payload.count || 0;
        state.totalPages = Math.ceil((action.payload.count || 0) / action.meta.arg.pagesize); // Use pagesize instead of limit
        state.currentPage = action.payload.next ? fetchedPage + 1 : fetchedPage;
        state.list = [...state.list, ...action.payload.results.data]; // Access results.data
        state.hasMore = !!action.payload.next;
      })
      .addCase(fetchPriorityList.rejected, (state, action) => {
        state.status = 'failed';
        state.loading = false;
        state.error = action.error.message;
      });
    builder
      .addCase(fetchPriorityListByID.pending, state => {
        state.status = 'loading';
        state.loading = false;
      })
      .addCase(fetchPriorityListByID.fulfilled, (state, action) => {
        state.status = 'succeeded';
        const fetchedPage = action.meta.arg.page || state.currentPage; // Use page from thunk args
        state.data = action.payload.results.data || []; // Access results.data
        state.totalRecord = action.payload.count || 0;
        state.totalPages = Math.ceil((action.payload.count || 0) / action.meta.arg.pagesize);
        state.currentPage = action.payload.next ? fetchedPage + 1 : fetchedPage;
        state.list = [...state.list, ...action.payload.results.data]; // Access results.data
        state.hasMore = !!action.payload.next;
      })
      .addCase(fetchPriorityListByID.rejected, (state, action) => {
        state.status = 'failed';
        state.loading = false;
        state.error = action.error.message;
      });

    builder
      .addCase(fetchArchivedPlanningList.pending, state => {
        state.status = 'loading';
        state.loading = true;
      })
      .addCase(fetchArchivedPlanningList.fulfilled, (state, action) => {
        state.status = 'succeeded';
        const fetchedPage = action.payload.page || state.currentpage;
        state.data = action.payload.results.data || [];  // Update to match your API response
        state.totalRecord = action.payload.count || 0; // Handle count (total records)
        state.totalPages = action.payload.totalPages || 0; // Handle totalPages
        state.currentpage = action.payload.next ? fetchedPage + 1 : fetchedPage;
        state.list = [...state.list, ...action.payload.results.data];
        state.hasMore = !!action.payload.next;
      })
      .addCase(fetchArchivedPlanningList.rejected, (state, action) => {
        state.status = 'failed';
        state.loading = false;
        state.error = action.error.message;
      });

    builder
      .addCase(createPlanning.pending, state => {
        state.status = 'loading';
        state.loading = true;
      })
      .addCase(createPlanning.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.loading = false;
        state.list.push(action.payload); // Add the newly created alloy to the list
      })
      .addCase(createPlanning.rejected, (state, action) => {
        state.status = 'failed';
        state.loading = false;
        state.error = action.payload;
      });

    builder
      .addCase(editPlanning.pending, state => {
        state.status = 'loading';
        state.loading = true;
      })
      .addCase(editPlanning.fulfilled, (state, action) => {
        state.status = 'succeeded';
        const index = state.data.findIndex(Size => Size.id === action.payload.id);
        if (index !== -1) {
          state.data[index] = action.payload; // Update the alloy in the state
        }
      })
      .addCase(editPlanning.rejected, (state, action) => {
        state.status = 'failed';
        state.loading = false;
        state.error = action.payload;
      });
    builder
      .addCase(fetchPlanningById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPlanningById.fulfilled, (state, action) => {
        state.loading = false;
        state.activeProfileRecord = action.payload;
      })
      .addCase(fetchPlanningById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    builder
      .addCase(archivePlanning.pending, state => {
        state.status = 'loading';
        state.loading = true;
      })
      .addCase(archivePlanning.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = state.data.filter(group => group.id !== action.payload); // Remove the deleted group from state
        state.list = state.list.filter(group => group.id !== action.payload); // Remove the deleted group from list
      })
      .addCase(archivePlanning.rejected, (state, action) => {
        state.status = 'failed';
        state.loading = false;
        state.error = action.payload;
      });

    builder
      .addCase(unArchivePlanning.pending, state => {
        state.status = 'loading';
        state.loading = true;
      })
      .addCase(unArchivePlanning.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = state.data.filter(group => group.id !== action.payload); // Remove the unarchived group from state
        state.list = state.list.filter(group => group.id !== action.payload); // Remove the unarchived group from list
      })
      .addCase(unArchivePlanning.rejected, (state, action) => {
        state.status = 'failed';
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const { resetPlanningList, resetCurrentPlanningListPage } = PlanningSlice.actions;
const { reducer } = PlanningSlice;
export default reducer;
